import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import '@/assets/styles/entry.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '@/assets/styles/globals.css';

import 'react-toastify/dist/ReactToastify.css';
import { router } from './router';

const root = createRoot(document.getElementById('root') as HTMLElement, {
    onRecoverableError: Sentry.reactErrorHandler(),
    onCaughtError: (error, errorInfo) => {
        // Log errors caught by Error Boundaries
        Sentry.captureException(error, {
            contexts: { react: errorInfo },
            tags: { error_type: 'caught' },
        });
    },
    onUncaughtError: (error, errorInfo) => {
        // Log uncaught errors that weren't handled by Error Boundaries
        Sentry.captureException(error, {
            contexts: { react: errorInfo },
            tags: { error_type: 'uncaught' },
        });
    },
});

root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);
